export const intro = [
  "Mutual funds are a pool of various stocks which are combined together in order to deliver exceptional returns. These stocks are brought by the combined wealth of multiple investors managed by fund houses and AMCs. The combined corpus is then invested across various companies and industries, across various sectors and economies. There are several types of funds depending upon the parameter chosen. The level of investment determines the share of returns, losses, expenses, and income of the fund in direct proportion",
  "The mutual funds (a combination of different stocks, bonds, etc) are created by bodies called fund houses and Asset Management Companies. These bodies are run and managed by experts and professionals across the industry called fund managers. A fund manager is responsible for managing the funds and timing markets in order the make the best out of investor’s money.",
  "There are plenty of options available to Indian investor offered by various fund houses and companies. These funds are regulated and governed by regulatory bodies- SEBI and AMFI for transparency and fairness. The performance of funds is mapped against the set benchmark.",
  "Investing in mutual funds allows investors to put their money at work in order to make more money for them. the performance of mutual funds is totally market driven i.e. a low market will attract loss while a high market will attract gains. It is important that investors understand the basic principles of investing in order to earn greater returns. There are different types of mutual fund categories available in the industry depending upon different parameters.",
  " Here is a broad classification of mutual funds under five categories-",
  [
    "Based on the asset class",
    " Based on the investment objective",
    " Based on risk factor",
    "Based on structure",
    "Specialized mutual funds"
  ]
];

export const equity = {
  heading: "Equity Funds",
  content: [
    "The funds which majorly invest in equities and equity-related instruments are called equity funds. a minimum of 65% of the assets is allocated towards equities in these funds. equity funds are slightly riskier as compared to other funds as they are completely ruled by the movement of the stock market.",
    "Portfolio diversification and diligent asset management are the two elements which help in risk management and its mitigation.",
    "There is a further subclassification of equity funds as:",
    [
      "Based on investment strategy",
      ["Value funds", "Dividend yield funds", "Focussed funds"],
      "Based on management",
      ["Active funds", "Passive funds"],
      "Based on the level of market capitalization",
      ["Small-cap funds", "Mid-cap funds", "Large-cap funds"],
      "Based on the theme",
      ["Sectoral funds", "Thematic funds"]
    ],
    "Equity funds are best suited for people who look forward to a long-term investment with a minimum span of 5 years in order to realize the maximum benefits of these funds. Also, they should have a moderate to high-risk appetite and are capable of generating greater returns."
  ]
};

export const debt = {
  heading: "DEBT FUNDS",
  content: [
    "Debt funds are the ones which majorly invest in fixed income assets and are less risky as compared to equity funds. the main components of a deb fund are treasury bills, corporate bonds, money market bills, debentures, gilt funds, commercial papers, government securities, and other debt-related instruments",
    "Debt funds are best suited for people who have a smaller risk appetite and look forward to a fixed income asset. Liquidity is another factor which attracts investors towards debt funds.",
    "There is a further sub-classification of debt funds as:",
    [
      "Short-term debt funds",
      "Ultra-short-term debt funds",
      "Liquid funds",
      "Dynamic bond funds"
    ]
  ]
};

export const hybrid = {
  heading: "Hybrid Funds",
  content: [
    "As the name suggests, hybrid funds are a mix of debt funds and equity funds bridging the gap between risk and return pillars. Hybrid funds are a combination of both the categories which is a covenant of low volatility or risk with long-term capital appreciation",
    "There are 2 major types of hybrid funds-",
    [
      {
        name: "Aggressive hybrid funds:",
        desc:
          "These funds majorly invest in equity stocks nearly 65-80% and the remaining is invested in debt stocks. The main aim of these funds is capital generation or growth."
      },

      {
        name: "Conservative Hybrid Funds:",
        desc:
          "These funds majorly invest in money-market instruments or debt funds. around 75-90% of the corpus is invested in debt funds and the remaining in equities. The main aim of these funds is capital preservation"
      }
    ],
    "Hybrid funds pledge the potential to cater to needs to every type of investor- aggressive and conservative. With the right asset allocation and selection of funds, hybrid funds can yield exceptional returns with comparatively low risk."
  ]
};

export const mfBasedOnObjective = [
  "Depending on the investment objective of an investor, mutual funds can be categorized into 6 different types, namely:",
  [
    "Growth funds",
    "Income funds",
    "Liquid funds",
    "Tax-saving funds or ELSS",
    "Capital protection funds",
    "Fixed maturity funds"
  ]
];

export const growth = {
  heading: "Growth Funds",
  content: [
    "Growth funds are the ones which focus on the capital generation and appreciation over the course of the investment. The primary investments are made in equities in order to maintain capital appreciation. Growth funds are generally diversified across various companies and industries for best results.",
    "Almost all mutual funds come with two options- growth or dividend under the same mutual fund. A growth option allows you to reinvest the returns into the principal amount and keep it invested further. A dividend or income option allows an investor to take out the dividend as a regular income or payment rather than reinvesting the returns",
    "Growth funds are best suited for people who wish to continue working for quite some time and have a moderate to high-risk appetite."
  ]
};

export const income = {
  heading: "Income Funds",
  content: [
    "Income funds are the ones which provide the investor with a regular income in the form of dividends. The main investments are made in high dividend potential stocks, government securities, debentures, bonds, etc. although there is no full-proof guarantee that a mutual fund is secure, income funds are most actively managed and hence provide with exceptional results as compared to other funds.",
    "Income funds are best suited for people who have a low-risk appetite and need a secure place to keep their money for short-term while enjoying regular income from them.",
    "Income funds are mostly chosen by people who have retired or are nearing retirement, conservative investors and new entrant to the investment industry."
  ]
};

export const liquid = {
  heading: "Liquid Funds",
  content: [
    "As the name suggests, liquid funds are the ones which pledge near-instant liquidity of the funds to investors. Liquidity and capital safety are the two main goals of these funds. the primary investment is made in high credit quality debt instruments plus the maturity period is kept limited to three months hence catering to the liquidity factor. Also, since the maturity period of funds is aligned with the maturity of the scheme, the market fluctuations do not cause much effect to it. "
  ]
};

export const elss = {
  heading: "ELSS OR TAX-SAVING FUNDS",
  content: [
    "ELSS or Equity-linked saving scheme is a tax saver plan which allows investors to invest money in a scheme which ensures long-term capital growth by investing in securities like shares, stocks, and equities while saving tax. Investments made under this plan are eligible for deductions under Section 80C of the Income Tax Act, 1961.",
    "Investing in the tax-saving scheme has been a trend for a long time which provides with returns at predetermined rates. This also allows investors to keep some portion of the income from being taxed. There is a lock-in period of 3 years with tax saving mutual funds which are 2 years less than the tax-saving fixed deposits and also provide with better returns as compared with the tax saving FDs"
  ]
};

export const capital = {
  heading: "CAPITAL PROTECTION FUNDS",
  content: [
    "Capital protection funds aim at preserving investor's capital while providing with growth and capital appreciation during the times of economic instability. The maturity if fund and debt portfolio in which the majority of the corpus is invested is aligned. This counters the market movements to a great extent. The investments are made in zero coupon debt funds and bonds with a little investment under equities as well.",
    "Capital protection funds are close-ended funds and cannot be redeemed or alter during the course of the investment. The lock-in period can be 1-year, 3-year or 5-year. Also, there is no guarantee of an assured return but history backs the fact that these funds have performed exceptionally well."
  ]
};

export const fixed = {
  heading: "FIXED MATURITY FUNDS",
  content: [
    "Fixed maturity funds majorly invest in debt funds having a predetermined maturity and are generally compared with fixed deposits. These funds come with a low expense ration as there is a one-time purchase of the stocks which are held till maturity. This also reduces the volatility factor to a great extent. Fixed maturity funds also come with tax benefits.",
    "These funds reflect a lot of characteristics of fixed deposits as they also invest majorly in debt funds and have a certain lock-in period like FDs. But one fact that differentiates them is that FDs have a fixed rate of interest while fixed maturity funds work with the market trends but work in sync with the indicative returns as mentioned at the time of purchase.",
    "The returns on these funds are taxable as per the applicable rule of either capital gain tax or dividend distribution tax."
  ]
};

export const riskFactorMf = [
  "There are four types of fund categories based on the risk factor, namely:",
  [
    "Ultra-low risk mutual funds",
    "Low-risk mutual funds",
    "Medium risk mutual funds",
    "High-risk mutual funds"
  ]
];

export const ultraLow = {
  content: [
    "Ultra-short-term funds, liquid funds, etc fall under the category of ultra-low risk funds. they carry very little risk and lower returns as compared to other funds but are known to be more productive than fixed deposits and savings accounts."
  ],
  heading: "ULTRA-LOW RISK MUTUAL FUNDS"
};

export const lowRisk = {
  heading: "LOW-RISK MUTUAL FUNDS",
  content: [
    "Investors with low-risk appetite find these funds attractive which invest majorly in arbitrage funds and low duration funds."
  ]
};

export const mediumRisk = {
  heading: "MEDIUM-RISK MUTUAL FUNDS",
  content: [
    "These are generally the balanced mutual funds which have an equitable distribution between debt and equity funds in order to cater to both high returns and moderate risk factor."
  ]
};

export const highRisk = {
  heading: "HIGH-RISK FUNDS",
  content: [
    "These are the extreme end of mutual funds as far as both risk and return factors are concerned. These are the most rewarding funds but come with a high-risk tab. The primary focus is on equities which is mainly done to maximize the returns the remaining portion of the portfolio is only invested in debt funds."
  ]
};

export const mfBasedOnStructure = [
  "Depending upon the structure of mutual funds, there are three types of mutual funds, namely:",
  ["Open-ended mutual funds", "Closed-ended mutual funds", "Interval funds"]
];

export const openEnded = {
  heading: "OPEN-ENDED MUTUAL FUNDS",
  content: [
    "Open-ended mutual funds are the ones which impart flexibility to the investors. The investor can sell and purchase the funds any time at their convenience. The entry and exit from the fund happen at the then current NAV of the fund. Due to the offered flexibility, the total unit capital of the fund keeps in changing time to time as investors enter and exit the fund."
  ]
};

export const closeEnded = {
  heading: "CLOSED-ENDED FUNDS",
  content: [
    "These are the funds which are fixed in nature and most aspects are predetermined like tenure, total unit capital, investment avenues, etc. The investors remain invested in the funds once the investment window closes. Neither sale nor purchase happens once the window is closed."
  ]
};

export const intervalFunds = {
  content: [
    "These funds are the way out between open-ended and closed-ended funds. with interval funds, the investors can enter or exit the fund at an interval which is prefixed by the fund house. Interval funds must not be confused with liquid funds as they do not assure liquidity at any time but only during the intervals that are pre-determined by the fund house.",
    "Interval funds have an additional advantage of investing in private assets and assets which are not listed on any exchange as well"
  ],
  heading: "INTERVAL FUNDS"
};

export const specialisedMf = [
  "Apart from the above parametrical categorization of mutual funds, there are funds which fall under this special category. These are:"
];

export const indexFunds = {
  heading: "Index Funds",
  content: [
    "These funds make investments in the stocks which belong to a particular index. Index funds only replicate the index as they are not actively managed. Since these funds are not exposed to the equity related volatility directly, the need for active management is not much. The returns are similar to the index returns and fall down proportionately when markets are low.",
    "The biggest benefit of these funds not being actively managed can be seen in their expense ration which is significantly lower than other funds.",
    "There are different types of index funds like;",
    {
      type: "Funds of funds",
      def:
        "Funds of funds are an indirect investment in the mutual funds by investing in other mutual funds rather than going directly for stocks or bonds. These are also referred to as multi-manager investment management funds. funds of funds allow the investor a great deal of diversification even in the foreign funds"
    },
    {
      type: "Foreign funds",
      def:
        "Foreign funds are popular as they provide portfolio diversification by allowing investments in the foreign funds and reduce the economic risk of a particular country which may also be referred to as domestic risk. They also approve of taking advantage of other countries booming economies. The investment in these funds can be made fully or partly."
    },
    {
      type: "Global Funds",
      def:
        "These funds make investments across the globe including the home country of the investor. These are the best investment avenues as far as correcting currency risk, domestic risk, economic risk, geopolitical risk is concerned. They are also known to make maximum out of different economies depending upon the market situation of the respective country."
    },
    {
      type: "Emerging market funds",
      def:
        "As the name suggests, these funds majorly invest in the markets of emerging economies and countries. Mostly smaller countries are targeted which are on their way to come up as a stable an developed economy to make the maximum benefit"
    },
    {
      type: "Sector funds",
      def:
        "These are the funds which are primarily equity-based and invest in a particular sector which is showing a rise. The essence of these funds in against diversification as they focus mainly on a sector or two to generate returns. For example, investing mainly in the pharmaceutical industry has been a common trend in the past decade. Although, investing all your money in a single sector can be hazardous at the times of market fall but a seasoned investor who has gained the knack of sectoral investing swear by it."
    },
    {
      type: "Thematic investing",
      def:
        "Thematic investing is similar to sectoral investing but on a way broader level. There is a lot of scope for diversification in thematic investing. For example, if the main theme of investment is the automobile industry, investors will invest their money in related industries as well, like oil and mining, steel and iron, rubber, leather, etc."
    },
    {
      type: "Asset allocation funds",
      def:
        "Asset allocation funds primarily focus on the right and most optimum allocation of assets in order to maximize the returns. They are tailor-made as per the need of investor and fall closer to the hybrid funds. there are two types of asset allocation funds- static and dynamic funds. while dynamic funds allow tailoring the allocation anytime, static funds are prefixed and decided upon."
    },
    {
      type: "Exchange traded funds (EFTs)",
      def:
        "ETF are traded like shares but in a slightly different manner. The investor cannot buy the stocks directly but own a share in the fund itself. ETF ensure high-end liquidity as they are bought and sold directly at the stock exchange. Only APs or Authorized Participants are allowed to make the transactions with ETFs."
    }
  ]
};

export const QnA = [
  {
    q: "How mutual funds work?",
    ans: [
      "Mutual funds are investment instruments which club the investments from various investors and invests them in the stock market under a given scheme. These funds are managed by a special body called Asset Management Company (AMC).",
      "The total pooled money is invested in different types of securities like debt funds, equity funds, bonds etc. the funds are managed by expert called Fund Manager as appointed by the AMC. A fund manager is responsible for managing the funds in accordance with the market corrections and creates wealth for the investors. An annual fee termed as Expense Ratio is charged from the investors against the services, they avail which is mainly managing their portfolio. The returns are generally in the form of capital appreciation or dividends. There is an option with the investors to either earn the gains as regular income or they can reinvest the returns back to the investment amount."
    ]
  },
  {
    q: "Why should I invest in mutual funds?",
    ans: [
      "While investing is the new trend in market especially with the young generation, multiple investing options may lead to confusion. Having these guidelines to the right investment approach may prove to be a blessing while taking an informed decision.",
      "Mutual funds are by far the most accepted form of investment for their unmatchable advantages",
      "We have listed some of the major aspects of mutual funds:",
      "1. Easy and Transparent: While investing directly in stock requires a lot of homework, time, knowledge and plenty of maths to do the trade, mutual funds are easy. Portfolio management with stocks is quite a task but when it comes to mutual funds you can even start with one.The basic funda is to identify your financial goal and once the What, When and How Much are clear, the maintenance goes from little to nil.",
      "2. Mutual fund Investments are Expert-Aide: Not everything has to be done by oneself when you have expert advice at hand (Check out www.piggy.co.in). Stock investments can be intricate. All the work is mechanistic in nature requiring long sitting hours in front of your laptop/ipad/cell phone just to get a flavour of what’s going on, leave alone investing,With mutual funds, you have a team of fund Managers who excel in making things simpler and make investing less tiresome.",
      "3. Diversified investments: Let’s jot the key points of mutual funds:",
      "a. Clubbed investments",
      "b. Professionally managed",
      "c. Multiple options",
      "d. Little maintenance",
      "e. Dependable",
      "Aren’t these more than enough to be inclined towards mutual funds and above all, it allows you a variety of options to stay invested in variety. You can always club your money and reap the benefits of multiple investments through distribution among funds.",
      "4. Risk distribution",
      "While investing does come with some associated risks, with mutual fund investments it’s on a decline. Let’s try and understand what risk means to you;",
      "Risk Types:",
      "1. Systematic risks",
      "         -Company risk",
      "         -Sector risk",
      "2. Unsystematic risks",
      "         -Market risk",
      "While systematic risks are bound, we need to cater to the unsystematic risk i.e. Market Risk.",
      "Let’s see this as:",
      "Case 1: Market is increasing, company performance is low",
      "The stock falls down",
      "Case 2: Market is decreasing, company is performing well",
      "The stock falls down!",
      "Hence it becomes very important to diversify the investment and distribute/reduce the risk.",
      "5. Balanced Transaction Costs",
      "Since the transactions are involved in large scale, per unit cost of transaction goes down to inconsequential hence leading to economies of scale as compared to direct stock investment.",
      "6. Investment Style Assortment",
      "As fancy the heading is, so sumptuous are the available options. Mutual funds are the only financial instrument offering a variety in terms of investment mode. You can opt for a Lumpsum or quarterly or monthly or weekly investment plan as your budget allows.",
      "Another way of looking at this is in what manner you want the money back-",
      "Long invested lumpsum amount: Growth Plan",
      "Regular income: Dividend Plan",
      "Also, you can adjust the intervals in which you want the regularised income",
      "7. Data availability",
      "While investing in stocks requires a great of data, information and knowledge, gathering information is a work already done in case of mutual funds. The funds come with all the necessary and desired information the investor needs to access only the performance of the fund he/she is interested in.",
      "8. Liquidity",
      "This aspect of mutual funds generally goes unaccounted for. Liquidity means how quickly you can get your hands on your cash. In simpler terms, liquidity is to get your money whenever you need it. It might be your emergency savings account or the cash lying with you that you can access in case of any unforeseen happening or any financial setback. Mutual funds offer easy conversion to cash as and when required hence keeping things simpler and urgent.",
      "9. Tax Efficiency",
      "Mutual funds are relatively more tax-efficient than other types of investments. You can invest in any mutual fund scheme with your bank account. Invest in tax saving mutual fund schemes (they are called Equity Linked Saving Schemes or ELSSs) and claim tax deductions of up to Rs 1.5 lakh under Section 80C.",
      "Mutual funds are the future of emerging markets. Stay invested and grow your wealth!"
    ]
  }
];
